// removed by extract-text-webpack-plugin
module.exports = {"fund-summary":"fund-summary__2MzpR","selector":"selector__2pKm9","ticker":"ticker__cj_WZ","summary":"summary__3mARJ"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/fundSummary.scss
// module id = 752
// module chunks = 68